import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg';
import { ReactComponent as FlagIcon } from 'assets/icons/flag.svg';
import { ReactComponent as RocketIcon } from 'assets/icons/rocket.svg';

export enum SortOptions {
  POSTS = 'posts',
  FLAGGED_POSTS = 'flaggedPosts',
  FLAGGED_COMMENTS = 'flaggedComments',
  COMMENTS = 'comments',
}

export type SortingOption = (typeof SORTING)[SortOptions][number];

export const SORTING = {
  [SortOptions.POSTS]: [
    {
      key: 'bestPosts',
      label: 'Best posts',
      icon: RocketIcon,
    },
    {
      key: 'latestPosts',
      label: 'Latest posts',
      icon: CalendarIcon,
    },
  ],
  [SortOptions.FLAGGED_POSTS]: [
    {
      key: 'oldest',
      label: 'Oldest',
      icon: CalendarIcon,
    },
    {
      key: 'mostFlagged',
      label: 'Most flagged',
      icon: FlagIcon,
    },
  ],
  [SortOptions.FLAGGED_COMMENTS]: [
    {
      key: 'oldest',
      label: 'Oldest',
      icon: CalendarIcon,
    },
    {
      key: 'mostFlagged',
      label: 'Most flagged',
      icon: FlagIcon,
    },
  ],
  [SortOptions.COMMENTS]: [
    {
      key: 'bestComments',
      label: 'Best comments',
      icon: RocketIcon,
    },
    {
      key: 'latestComments',
      label: 'Latest comments',
      icon: CalendarIcon,
    },
  ],
} as const;
